import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Gracias() {
  return (
    <main className="thanks-page" style={{ textAlign: 'center', padding: '100px 20px' }}>
      <Helmet>
        <title>¡Gracias por tu interés! - Culturlingua</title>
        <meta name="robots" content="noindex" /> {/* No queremos que aparezca en Google, solo vía el formulario */}
      </Helmet>
      <h1>¡Tu mensaje ha sido enviado! 🚀</h1>
      <p>Un asesor de Culturlingua se pondrá en contacto contigo muy pronto.</p>
      <Link to="/" className="cta-button virtual-btn">Volver al inicio</Link>
    </main>
  );
}

export default Gracias;